import React, { useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Container,
  Paper,
  List,
  ListItem,
  ListItemText,
  Box,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const DissertationServices: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const otherServices = [
    { title: "Dissertation", route: "/dissertation-writing-services" },
    { title: "Data analytics", route: "/data-analysis-services" },
    { title: "Project writing services", route: "/project-report-writing" },
    { title: "Publication", route: "/publication-services" },
    { title: "Literature review", route: "/literature-review-writing" },
    { title: "Manuscript", route: "/manuscript-preparation" },
    { title: "Research methodology", route: "/research-methodology-services" },
  ];

  const data = {
    icon: "ds3.webp",
    title: "Coursework",
    image: "ds3.webp",
    description:
      "Get help from top-notch researchers to deliver high-quality academic papers.",
    additionalInfo: [
      {
        title: "Assignment",
        icon1: "",
        description:
          "An assignment in assignment writing for research papers involves selecting a topic, conducting thorough research, and presenting findings in a structured format. It requires critical analysis, proper citation of sources, and a clear argument to support the research objectives. This process helps develop strong academic writing skills and contributes to a deeper understanding of the subject matter.",

        cards: [
          {
            title: "Topic Selection",

            description:
              "Choosing the right topic is crucial for a research paper assignment. It must be specific, researchable, and aligned with the objectives of the paper. A well-chosen topic ensures focused research and coherent writing.",
          },
          {
            title: "Thesis Statement",

            description:
              "A clear thesis statement is the foundation of any research paper. It presents the main argument or purpose of the paper, guiding the direction of the research and writing while helping to maintain focus throughout the assignment.",
          },
          {
            title: "Research and Sources",

            description:
              "Effective research is essential for a strong research paper. This topic involves gathering credible and relevant sources, ensuring that the arguments are well-supported and backed by evidence, which adds depth and reliability to the paper.",
          },
          {
            title: "Proper Citation and Formatting",

            description:
              "Citing sources correctly and following the required formatting style (e.g., APA, MLA) is critical in academic writing. This topic highlights the importance of avoiding plagiarism and adhering to academic standards, ensuring integrity and professionalism in the research paper.",
          },
        ],
      },
      {
        title: "Exam-Notes",
        icon1: "",

        description:
          "At our company, we offer tailored support for creating effective exam notes in assignment writing for research papers. Our team helps students organize and summarize key concepts, theories, and arguments related to their research topics. These concise notes serve as valuable tools for exam preparation and quick reference, ensuring a solid understanding of the material. By streamlining the research and writing process, our expertly crafted exam notes empower students to confidently tackle both assignments and exams.",

        cards: [
          {
            title: "Key Concept Identification",

            description:
              "Effective exam notes start with identifying the most important concepts and theories from the research. This helps students focus on the core material, ensuring they grasp essential ideas that will likely be tested in exams.",
          },
          {
            title: "Summarization Techniques",

            description:
              "Summarizing lengthy research into concise, understandable notes is key. This topic emphasizes how to condense complex information while retaining crucial details, making the notes easy to review and use as a study guide.",
          },
          {
            title: "Organized Structure",

            description:
              "A well-organized structure is vital for effective exam notes. This includes using headings, bullet points, and sections to make the notes easy to navigate, ensuring that students can quickly find and review important information.",
          },
          {
            title: "Application to Exam Questions",

            description:
              "Good exam notes should not just summarize information but also help in applying knowledge to potential exam questions. This topic covers how to tailor notes to highlight important arguments, examples, and research findings relevant to anticipated exam topics.",
          },
        ],
      },
      {
        title: "synopisis preparation ",
        icon1: "",

        description:
          "At our company, we specialize in assisting students with synopsis preparation for research papers. We help craft concise summaries that outline the key elements of their research projects, including the research problem, objectives, methodology, and expected outcomes. Our expertly prepared synopses serve as clear roadmaps, ensuring that students effectively communicate the focus and direction of their research. By working with us, students can confidently present their ideas and gain a solid understanding of their projects, making the research process more organized and manageable.",

        cards: [
          {
            title: "Understanding the Research Problem",

            description:
              "A clear understanding of the research problem is fundamental to synopsis preparation. This topic focuses on articulating the issue being addressed, ensuring that the synopsis effectively communicates its significance and relevance within the field.",
          },
          {
            title: "Defining Objectives and Hypotheses",

            description:
              "Defining the objectives and hypotheses provides a roadmap for the research. This section should outline the specific aims of the study and any hypotheses to be tested, giving readers insight into the intended outcomes of the research.",
          },
          {
            title: "Methodology Overview",

            description:
              "The methodology section in the synopsis outlines the research design and methods to be used. This topic emphasizes the importance of presenting a clear and concise explanation of how the research will be conducted, ensuring transparency and reproducibility.",
          },
          {
            title: "Expected Outcomes and Significance",

            description:
              "Discussing the expected outcomes and the significance of the research helps contextualize the study. This topic highlights the importance of articulating what the research aims to achieve and its potential contributions to the field, engaging the interest of readers and evaluators.",
          },
        ],
      },
      {
        title: "Interim Report",
        icon1: "",

        description:
          "At our company, we specialize in helping students create interim reports for their research paper assignments. We assist in outlining progress, including completed work, initial findings, and any challenges encountered. Our comprehensive interim reports enable students to evaluate their project's direction and ensure they stay on track to meet their objectives. With our support, students can effectively communicate their progress and receive valuable feedback for the next stages of their research.",

        cards: [
          {
            title: "Progress Overview",

            description:
              "Presenting initial findings is crucial for demonstrating the research's early outcomes. This topic discusses any data or insights gathered so far, helping to illustrate how the research aligns with the objectives and indicating potential trends or results.",
          },
          {
            title: "Challenges and Solutions",

            description:
              "Identifying challenges encountered during the research process is essential for transparency. This section discusses any obstacles faced and the solutions implemented, showcasing the researcher’s problem-solving skills and adaptability.",
          },
          {
            title: "Initial Findings",
            description:
              "Presenting initial findings is crucial for demonstrating the research's early outcomes. This topic discusses any data or insights gathered so far, helping to illustrate how the research aligns with the objectives and indicating potential trends or results.",
          },
          {
            title: "Next Steps",

            description:
              "The next steps section outlines the plan for the remaining stages of the research. This topic emphasizes the intended actions, adjustments to the research plan, and timelines for completing the project, ensuring clarity and focus moving forward.",
          },
        ],
      },
      {
        title: "PowerPoint",
        icon1: "",

        description:
          "At our company, we assist students in creating impactful PowerPoint presentations for their research papers. We help them summarize key findings and concepts clearly and engagingly, emphasizing the use of well-structured slides with visuals and data. Our goal is to empower students to present their research confidently, facilitating interaction and discussion while ensuring their ideas resonate with the audience.",

        cards: [
          {
            title: "Slide Design and Layout",

            description:
              "Effective slide design is crucial for enhancing audience engagement. This topic covers principles of layout, including font size, color schemes, and the use of white space, ensuring that slides are visually appealing and easy to read.",
          },
          {
            title: "Content Organization",

            description:
              "Organizing content logically is essential for clarity. This topic discusses how to structure slides, including the introduction, key findings, and conclusions, helping students present their research in a coherent and flow-driven manner.",
          },
          {
            title: "Visual Aids",

            description:
              "Incorporating visual aids, such as graphs, charts, and images, enhances understanding and retention of information. This topic emphasizes the importance of selecting relevant visuals that complement the presentation and illustrate key points effectively.",
          },
          {
            title: "Presentation Skills",

            description:
              "Strong presentation skills are vital for delivering an impactful PowerPoint. This topic focuses on verbal communication, body language, and audience interaction techniques, equipping students to present their research confidently and engage their audience effectively.",
          },
        ],
      },
    ],
  };
  const handleServiceClick = (route: string) => {
    window.location.href = route;
  };

  const handleHeadingClick = (index: number) => {
    setActiveIndex(activeIndex === index ? 0 : index);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Grid
        container
        spacing={0}
        sx={{
          backgroundColor: "#172554",
          padding: { sm: 0, lg: 3 },
          display: "flex",
          flexDirection: "row-reverse",
        }}
        className="component"
      >
        {/* Left Side - Other Services List (Desktop) and Expandable Headings (Mobile) */}
        <Grid item xs={12} md={3}>
          {/* Desktop View */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <List>
              {data.additionalInfo.map((info, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleHeadingClick(index)}
                  selected={activeIndex === index}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={info.title} />
                </ListItem>
              ))}
              <Typography
                sx={{ textAlign: "center", color: "white", fontWeight: "bold" }}
              >
                Our Other Services
              </Typography>
              {otherServices.map((service, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleServiceClick(service.route)}
                  sx={{ color: "white" }}
                >
                  <ListItemText primary={service.title} />
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Mobile View - Expandable Headings */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {data.additionalInfo.map((info, index) => (
              <Box key={index}>
                <ListItem
                  button
                  onClick={() => handleHeadingClick(index)}
                  sx={{
                    color: "white",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <ListItemText primary={info.title} />
                  <IconButton sx={{ color: "white" }}>
                    {activeIndex === index ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                </ListItem>
                <Collapse
                  in={activeIndex === index}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      backgroundColor: "#f3f4f6",
                      color: "black",
                      padding: 2,
                    }}
                  >
                    <Typography variant="body2" sx={{ marginBottom: 2 }}>
                      {info.description}
                    </Typography>
                    {info.cards.map((card, cardIndex) => (
                      <Card
                        key={cardIndex}
                        sx={{
                          marginBottom: 2,
                          backgroundColor: "#172554",
                          color: "white",
                        }}
                      >
                        <CardContent>
                          <Typography variant="h6" >
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2">
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Collapse>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Right Side - Dissertation Content (Desktop Only) */}
        <Grid item md={9} sx={{ display: { xs: "none", md: "block" } }}>
          <Paper
            elevation={3}
            sx={{
              padding: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#f3f4f6",
              boxShadow: "none",
              borderRadius: "0px",
            }}
          >
            {activeIndex !== null && (
              <>
                <Typography variant="h5" sx={{ marginBottom: 2 }}>
                  {data.additionalInfo[activeIndex].title}
                </Typography>
                <Box sx={{ marginBottom: 2 }}></Box>
                <Typography sx={{ marginBottom: 4, textAlign: "center" }}>
                  {data.additionalInfo[activeIndex].description}
                </Typography>

                <Grid
                  container
                  direction="column"
                  spacing={2}
                  sx={{
                    backgroundColor: "#172554",
                    color: "white",
                    borderRadius: "4px",
                    maxWidth: { lg: "75%", xs: "100%" },
                  }}
                >
                  {data.additionalInfo[activeIndex].cards.map((card, index) => (
                    <Grid item key={index}>
                      <Card
                        sx={{
                          boxShadow: "none",
                          backgroundColor: "transparent",
                          color: "white",
                        }}
                      >
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="h6" color={"white"}>
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#f97316", paddingRight: "10px" }}
                            ></i>
                            {card.title}
                          </Typography>
                          <Typography variant="body2" textAlign={"center"}>
                            {card.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DissertationServices;
